import { ICustomTheme } from 'interfaces';
import { Typography } from '@material-ui/core';
import styled from '@emotion/styled';

type Theme = {
  theme?: ICustomTheme;
};

export const Container = styled.div<Theme>({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
});

export const Title = styled(Typography)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  textAlign: 'center',
  marginBottom: theme.spacing(2),
}));
